const Heros = (($) => {
  let _els = {};

  const init = () => {
    gsap.registerPlugin(ScrollTrigger);

    _initScroll();
    _initHeroRotator();
  };

  const _initScroll = () => {

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#primary-header .navbar',
        start: "top top", // when the top of the trigger hits the top of the viewport
        end: "+=96", // end after scrolling beyond the start
        scrub: true
      }
    });

    tl.to('#primary-header .navbar .navbar-brand img', 1, {
        // scale: .80,
        width: '132px'
      }, 0)
      .to('#primary-header .navbar', 1, {
        paddingTop: '10px',
        paddingBottom: '10px'
      }, 0)
      .to('#primary-header .btn-primary', 1, {
        padding: '5px 10px',
      }, 0);

  };

  const _initHeroRotator = () => {

    _els.heroGallery = $('.hero__images__gallery');
    _els.heroGalleryImages = $('.hero__images__gallery .hero__images__image');

    let currentIndex = 0;
    let itemInterval = 5000;
    let numItems = _els.heroGalleryImages.length;

    // return if there's only 1
    if (numItems <= 1) return;

    // Fade in/out
    _interval(() => {

      // hide current
      _els.heroGalleryImages.eq(currentIndex).removeClass('active');

      // increment
      if (currentIndex === numItems - 1) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }

      // show next
      _els.heroGalleryImages.eq(currentIndex).addClass('active');
    }, itemInterval, 100);
  };

  // Custom interval function
  const _interval = (func, wait, times) => {
    let interv = ((w, t) => {
      return () => {
        if (typeof t === 'undefined' || t-- > 0) {
          setTimeout(interv, w);
          try {
            func.call(null);
          } catch (e) {
            t = 0;
            throw e.toString();
          }
        }
      };
    })(wait, times);

    setTimeout(interv, wait);
  };

  module.exports = {
    init: init,
  };
})(jQuery);
